import { defineComponent as _defineComponent } from 'vue'
import { computed as _computed } from 'vue';

import __MACROS_useVModel from "/vue-macros/define-models/use-vmodel";
import i18n from '@/i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'Days-Selector',
  props: {
  value: null
},
  emits: ["input"],
  setup(__props) {


const innerIcon = _computed(() => 'icon-clock');

const historyDaysList = [
  { value: 7, text: `7 ${i18n.t('dashboard.days')}` },
  { value: 14, text: `14 ${i18n.t('dashboard.days')}` },
  { value: 30, text: `30 ${i18n.t('dashboard.days')}` },
  { value: 90, text: `90 ${i18n.t('dashboard.days')}` },
];

const { value: historyDays } = __MACROS_useVModel(["value", undefined, "input"]);

return { __sfc: true,innerIcon, historyDaysList, historyDays, _computed, __MACROS_useVModel, i18n }
}

})